const PDF_API_ENDPOINT = 'https://hmjfdzxho8.execute-api.us-east-1.amazonaws.com/dev/send-pdf'

window.sendPDFToAPI = async (emailData) => {
  const response = await fetch(PDF_API_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(emailData)
  })

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`HTTP ${response.status}: ${errorText}`)
  }

  return await response.json()
}

const sendPDFStandalone = async (emailData) => {
  return await window.sendPDFToAPI(emailData)
}

console.log('sendPDF.js loaded - sendPDFToAPI available globally')